if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.content = this.querySelector('[role="document"]');
        this.prevBtn = this.querySelector('.bl-pm-nav--prev');
        this.nextBtn = this.querySelector('.bl-pm-nav--next');
        this.counter = this.querySelector('.bl-pm-counter');
        this.currentIndex = 0;

        [this.prevBtn, this.nextBtn, this.counter].forEach((el) => {
          // Dawn closes media-modal on any mouse pointerup — keep nav clicks inside
          if (el) el.addEventListener('pointerup', (e) => e.stopPropagation());
        });
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(1));

        this.addEventListener('keyup', (e) => {
          if (e.code === 'ArrowLeft') this.go(-1);
          if (e.code === 'ArrowRight') this.go(1);
        });

        // Swipe (mobile)
        let sx = 0;
        let sy = 0;
        this.content.addEventListener(
          'touchstart',
          (e) => {
            sx = e.touches[0].clientX;
            sy = e.touches[0].clientY;
          },
          { passive: true }
        );
        this.content.addEventListener(
          'touchend',
          (e) => {
            const dx = e.changedTouches[0].clientX - sx;
            const dy = e.changedTouches[0].clientY - sy;
            if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) this.go(dx < 0 ? 1 : -1);
          },
          { passive: true }
        );
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      // Same set the PDP gallery shows: non-variant media + the opened one
      getItems() {
        const openedId = this.openedBy ? this.openedBy.getAttribute('data-media-id') : null;
        return Array.from(this.content.children).filter(
          (el) =>
            el.hasAttribute('data-media-id') &&
            (!el.classList.contains('product__media-item--variant') || el.getAttribute('data-media-id') === openedId)
        );
      }

      showActiveMedia() {
        this.items = this.getItems();
        const openedId = this.openedBy.getAttribute('data-media-id');
        const index = this.items.findIndex((el) => el.getAttribute('data-media-id') === openedId);
        this.setActive(index < 0 ? 0 : index);
      }

      go(step) {
        if (!this.items || this.items.length < 2) return;
        this.setActive(this.currentIndex + step);
      }

      setActive(index) {
        const total = this.items.length;
        this.currentIndex = (index + total) % total;

        window.pauseAllMedia();
        this.content.querySelectorAll('[data-media-id]').forEach((el) => el.classList.remove('active'));

        const activeMedia = this.items[this.currentIndex];
        activeMedia.classList.add('active');
        this.content.scrollTop = 0;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA') {
          if (!activeMedia.getAttribute('loaded')) {
            activeMedia.loadContent(false);
          } else {
            const video = activeMedia.querySelector('video');
            if (video) video.play();
          }
        }

        if (this.counter) this.counter.textContent = `${this.currentIndex + 1} / ${total}`;
        this.toggleAttribute('data-single', total < 2);
      }
    }
  );
}
